// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"e894f205","283":"8c50677c","366":"36ad6b65","761":"768eb844","834":"db425a79"}[chunkId] + ".chunk.css";
};